var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.17247 0.167368C0.402431 -0.0557892 0.775271 -0.0557892 1.00523 0.167368L4.12195 3.19188C4.58188 3.63819 4.58188 4.36181 4.12195 4.80812L1.00523 7.83263C0.775271 8.05579 0.402431 8.05579 0.17247 7.83263C-0.0574901 7.60948 -0.0574901 7.24767 0.17247 7.02451L3.28919 4L0.17247 0.97549C-0.0574901 0.752333 -0.0574901 0.390524 0.17247 0.167368ZM3.70557 0.167368C3.93553 -0.0557892 4.30837 -0.0557892 4.53833 0.167368L7.65506 3.19188C8.11498 3.63819 8.11498 4.36181 7.65506 4.80812L4.53833 7.83263C4.30837 8.05579 3.93553 8.05579 3.70557 7.83263C3.47561 7.60948 3.47561 7.24767 3.70557 7.02451L6.8223 4L3.70557 0.97549C3.47561 0.752333 3.47561 0.390524 3.70557 0.167368Z",
    fill: "#747272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowRight);
export default __webpack_public_path__ + "static/media/DoubleArrowRight.fa68bea00f65c23d50a15954aeee986a.svg";
export { ForwardRef as ReactComponent };